import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux'
import AJAX from '../functions/ajax'

import AA_GLOBAL from "../globals/globals"
import Routes from "../Routes"

// REDUX
import { logout, saveSessionAndInfo } from "../actions/userActions";

// COMPONENTS
import ContentGenerator from '../components/layout/ContentGenerator';
import MainHeaderNav from '../components/navigations/MainHeaderNav';
import MainBoxNav from '../components/navigations/MainBoxNav';
import FooterMain from '../components/footers/FooterMain';

// FUNCTIONS
import fetchAndSetFormioLocale from "../functions/fetchAndSetFormioLocale";

// HOC
import AppHOC from '../hoc/AppHOC';

import { saveInfo } from "../actions/appActions";
import { Route } from 'react-router-dom';

export class Pages extends Component {
  state = {
    renderPage: false,
    rerender: 1
  }

  componentDidMount() {
    if (this.props.info) {
      this.setState({rerender: Math.random()})
    }else {
      AJAX().getAppInfo("h87rt5r57765785578357")
      .then(res => {
        this.props.saveInfo(res.data)
      })
    }
  }



  render() {

    if(!this.props.info) return null
    return (
    <AppHOC>
    <div id="page">
      <MainHeaderNav/>
      <MainBoxNav/>
      <div className="rowCon rowCon__withMargin" id="main_content">
        <div className="dashboardMain">

            <ContentGenerator
              url={`/api/page/${this.props.match.params.slug}`}/>

        </div>
      </div>
      <FooterMain/>
    </div>
    </AppHOC>
    );
  }
}


const mapStateToProps = store => ({
  user: store.user,
  info: store.app.info,
});

export default connect(mapStateToProps, { saveInfo })(injectIntl(Pages))
